import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomePageOffers } from "../../../../../containers/Home/redux/thunks";
import * as LOADERSTYLE from '../../loader/loaderBanner.styles';
import LineLoader from '../../../../../../stories/core-components/LineLoader/LineLoader';
import { homeOffersSelector } from '../../../../../containers/Home/redux/selectors';
import OfferBanner from "./OfferBanner";

const OfferBannerWrapper = () => {
    const dispatch = useDispatch();
    const { offers } = useSelector(homeOffersSelector);
    const renderBanner = offers && offers.data && offers.data.length;

    useEffect(() => {
        dispatch(fetchHomePageOffers());
        return () => { };
    }, []);

    return (<>
        {renderBanner ? <OfferBanner data={offers.data} /> :
            <LOADERSTYLE.Loader>
                <LOADERSTYLE.RecentSearchLoader>
                    <LOADERSTYLE.LoaderColumn>
                        <LineLoader width="100%" height="110px" />
                        <div>
                            <LineLoader width="100%" height="1.6rem" />
                            <LineLoader width="75%" height="1.6rem" />
                        </div>
                    </LOADERSTYLE.LoaderColumn>
                    <LOADERSTYLE.LoaderColumn>
                        <LineLoader width="100%" height="110px" />
                        <div>
                            <LineLoader width="100%" height="1.6rem" />
                            <LineLoader width="75%" height="1.6rem" />
                        </div>
                    </LOADERSTYLE.LoaderColumn>
                </LOADERSTYLE.RecentSearchLoader>
            </LOADERSTYLE.Loader>
        }
    </>);
}

export default OfferBannerWrapper;
